import api from './api';
import { isValidOpaqueRefreshToken, clearAuthData } from './auth';

/**
 * The one sign-out path.
 *
 * Revoking the refresh token server-side is the part that actually ends the
 * session: clearing localStorage alone leaves a 7-day refresh token valid and
 * usable. The network call is best-effort — a failed request must still clear
 * the local session rather than trapping the user signed in.
 */
export async function signOut() {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    if (isValidOpaqueRefreshToken(refreshToken)) {
      await api.post('/api/auth/logout', { refreshToken: refreshToken.trim() });
    }
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    clearAuthData();
    try {
      localStorage.removeItem('verificationPending');
      localStorage.removeItem('activationPromptDismissed');
      sessionStorage.removeItem('velox:avatar');
    } catch {
      /* storage can be unavailable in private modes; the token is already gone */
    }
  }
}

export default signOut;
